// extracted by mini-css-extract-plugin
export var workout = "style-module--workout--a7d28";
export var workout__btn = "style-module--workout__btn--cae6c";
export var workout__container = "style-module--workout__container--89038";
export var workout__description = "style-module--workout__description--0c459";
export var workout__img = "style-module--workout__img--f3d43";
export var workout__info = "style-module--workout__info--5bd9c";
export var workout__title = "style-module--workout__title--23624";